import OpenOrders from "../components/app/Order/OpenOrders";

export default function OpenOrderPage (){
    return(
        <OpenOrders/>
    )
};